import React, {useEffect, useState} from "react";
import {
    Navbar,
    Page,
    Preloader,
    Actions,
    ActionsButton,
    ActionsGroup,
    f7,
    Card,
    CardContent, NavLeft, NavTitle, NavRight,
} from "framework7-react";
import {getCurrentAtagLocal, getDefaultAtag, getUserAuthData} from "../../auth/authHelper";
import {useAction} from "../../../store/hooks/useAction";
import {useTypedSelector} from "../../../store/hooks/useTypedSelector";
import {TicketSection} from "./TicketSection";
import {useTranslation} from "react-i18next";
import {getStoragedCurrentOperator, getStoragedOperatorInfo} from "../../auth/authHelper";
import {MainToolBar} from "../../MainLayout/MainToolBar";
import {QRCodeModal} from "./QRCode/QRCodeModal";
import './Tickets.css'
const toAbsoluteUrl = (pathname: string) => process.env.PUBLIC_URL + pathname;
export const Tickets: React.FC = () => {
    const { t } = useTranslation();
    const storedAtag = getCurrentAtagLocal();
    const defaultAtag = getDefaultAtag();
    const initialAtag = storedAtag?.length > 0 ? storedAtag : defaultAtag;
    const storedOperatorValue = getStoragedCurrentOperator();
    const operatorName = getStoragedCurrentOperator();
    const operatorData = getStoragedOperatorInfo();
    const [actionsGridOpened, setActionsGridOpened] = useState(false);
    const [selectedTicket, setSelectedTicket] = useState<any>(null);
    const [selectedTicketType, setSelectedTicketType] = useState<string>('');
    const operatorTicketUrl = operatorData?.website_url;
    const [visibleCounts, setVisibleCounts] = useState({
        quickbets: 5,
        jackpots: 5,
        smartbets: 5,
        quicktips: 5,
        superbets: 5,
    });
    const [qrModalOpened, setQrModalOpened] = useState(false);
    const [qrUrl, setQrUrl] = useState('');
    const setVisibleCount = (key: keyof typeof visibleCounts) => (value: React.SetStateAction<number>) =>
        setVisibleCounts(prev => ({ ...prev, [key]: typeof value === "function" ? value(prev[key]) : value }));

    const { getQuickbetsData, getJackpotsData, getSuperbetsData, getSmartBetsData, getQuicktipsData } = useAction();
    const { quickbetsData, loading } = useTypedSelector(state => state.quickbetsReducer);
    const { jackpotsData } = useTypedSelector(state => state.jackpotsReducer);
    const { superbetsData } = useTypedSelector(state => state.superbetsReducer);
    const { smartBetsData } = useTypedSelector(state => state.smartBetsReducer);
    const { quicktipsData } = useTypedSelector(state => state.quicktipsReducer);

    const onTicketClick = (ticket: any, ticketType: string) => {
        setSelectedTicket(ticket);
        setSelectedTicketType(ticketType);
        setActionsGridOpened(true);

    };

    useEffect(() => {
        if (operatorName) {
            getQuickbetsData(operatorName);
            getQuicktipsData(operatorName);
            getJackpotsData(operatorName);
            getSuperbetsData(operatorName);
            getSmartBetsData(operatorName);
        }
    }, [operatorName]);

    return (
        <Page>
            <Navbar style={{ height: "60px" }}>
                <NavLeft />
                <NavTitle>
                    <img
                        src={toAbsoluteUrl(`/img/operator_logo/logo_${storedOperatorValue}.webp`)}
                        onError={(e) => {
                            e.currentTarget.src = toAbsoluteUrl(`/img/operator_logo/betstack_logo.png`);
                        }}
                        alt="Logo"
                        style={{ height: "30px" }}
                    />
                </NavTitle>
                <NavRight />
            </Navbar>
            {loading ? <Preloader /> : (
                <div style={{marginBottom: '70px', marginTop: '30px'}}>
                    <TicketSection
                        title="ticketsPage.quickbetTitle"
                        description="ticketsPage.quickbetPromoText"
                        items={quickbetsData}
                        visibleCount={visibleCounts.quickbets}
                        setVisibleCount={setVisibleCount("quickbets")}
                        onTicketClick={onTicketClick}
                        ticketType={'quickbet'}
                    />

                    <TicketSection
                        title="ticketsPage.jackpotTitle"
                        description="ticketsPage.jackpotPromoText"
                        items={jackpotsData}
                        visibleCount={visibleCounts.jackpots}
                        setVisibleCount={setVisibleCount("jackpots")}
                        onTicketClick={onTicketClick}
                        link="/jackpots/"
                        ticketType={'jackpot'}
                    />

                    <TicketSection
                        title="ticketsPage.smartbetTitle"
                        description="ticketsPage.smartbetPromoText"
                        items={smartBetsData}
                        visibleCount={visibleCounts.smartbets}
                        setVisibleCount={setVisibleCount("smartbets")}
                        onTicketClick={onTicketClick}
                        ticketType={'smartbet'}
                    />

                    <TicketSection
                        title="ticketsPage.quicktipTitle"
                        description="ticketsPage.quicktipPromoText"
                        items={quicktipsData}
                        visibleCount={visibleCounts.quicktips}
                        setVisibleCount={setVisibleCount("quicktips")}
                        onTicketClick={onTicketClick}
                        ticketType={'quicktip'}
                    />

                    <TicketSection
                        title="ticketsPage.superbetTitle"
                        description="ticketsPage.superbetPromoText"
                        items={superbetsData}
                        visibleCount={visibleCounts.superbets}
                        setVisibleCount={setVisibleCount("superbets")}
                        onTicketClick={onTicketClick}
                        ticketType={'superbet'}
                    />
                </div>
            )}

            <Actions
                grid
                opened={actionsGridOpened}
                onActionsClosed={() => setActionsGridOpened(false)}
            >
                {selectedTicket && (
                    <>
                        <div style={{padding: '8px', width: '100%', boxSizing: 'border-box'}}>
                            <Card className='text-align-center' style={{margin: 0}}>
                                <CardContent>
                                    <div className='modal-header bold-text'>{selectedTicketType}</div>
                                    <div className="ticket_preview_block">
                                        <div className="logo">
                                            <img
                                                slot="media"
                                                src={selectedTicket.preview_img}
                                                width="80"
                                                height="80"
                                                style={{ borderRadius: '8px' }}
                                            />
                                        </div>
                                        <div className="ticket-info">
                                            <div className='bold-text'>{selectedTicket.sitename}</div>
                                            <div>{selectedTicket.preview_title}</div>
                                            <div className='hint-text-color'>{selectedTicket.description}</div>
                                            <div>{t('ticketsPage.ticketCode')}: {selectedTicket.code}</div>
                                            {/*{*/}
                                            {/*    selectedTicket?.operator_time_expires &&*/}
                                            {/*    <p>{t('ticketsPage.operatorTimeExpires')}: {updateDate(selectedTicket?.operator_time_expires, t).formattedDate}</p>*/}
                                            {/*}*/}
                                        </div>
                                    </div>
                                </CardContent>
                            </Card>
                        </div>

                        <ActionsGroup>
                            <ActionsButton>
                                <a
                                    href={`https://www.facebook.com/sharer/sharer.php?u=${operatorTicketUrl}/${selectedTicketType}/${selectedTicket?.code}?atag=${initialAtag}`}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="external"
                                >
                                    <i className="f7-icons size-22">logo_facebook</i>
                                    <div>Facebook</div>
                                </a>
                            </ActionsButton>
                            <ActionsButton>
                                <a
                                    href={`https://t.me/share/url?url=${operatorTicketUrl}/${selectedTicketType}/${selectedTicket?.code}?atag=${initialAtag}`}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="external"
                                >
                                    <img
                                        width="26"
                                        src={toAbsoluteUrl(`/img/icons/telegram-icon-size_64.png`)}
                                    />
                                    <div>Telegram</div>
                                </a>
                            </ActionsButton>

                            <ActionsButton>
                                <a
                                    href={`https://api.whatsapp.com/send?text=${operatorTicketUrl}/${selectedTicketType}/${selectedTicket?.code}?atag=${initialAtag}`}
                                    target="_blank"
                                    className="external"
                                >
                                    <img
                                        width="26"
                                        src={toAbsoluteUrl(`/img/icons/whatsapp-square-icon-size_64.png`)}
                                    />
                                    <div>Whatsapp</div>
                                </a>
                            </ActionsButton>
                            <ActionsButton>
                                <a
                                    href={`https://twitter.com/intent/tweet?url=${operatorTicketUrl}/${selectedTicketType}/${selectedTicket?.code}?atag=${initialAtag}`}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="external"
                                >
                                    <i className="f7-icons size-22">logo_twitter</i>
                                    <div>Twitter</div>
                                </a>
                            </ActionsButton>
                            <ActionsButton onClick={() => {
                                const url = `${operatorTicketUrl}/${selectedTicketType}/${selectedTicket?.code}?atag=${initialAtag}`;
                                setQrUrl(url);
                                setQrModalOpened(true);
                            }}>
                                <i className="f7-icons size-22">qrcode</i>
                                <div>QRCode</div>
                            </ActionsButton>
                            <ActionsButton onClick={() => {
                                const url = `${operatorTicketUrl}/${selectedTicketType}/${selectedTicket?.code}?atag=${initialAtag}`;
                                navigator.clipboard.writeText(url)
                                    .then(() => f7.dialog.alert(t('notifications.linkCopied')))
                                    .catch(() => f7.dialog.alert(t('notifications.copyFailed')));
                            }}>
                                <i className="f7-icons size-22">doc_on_doc</i>
                                <div>{t('btn.copy')}</div>
                            </ActionsButton>
                        </ActionsGroup>
                    </>
                )}

                <ActionsGroup>
                    <ActionsButton
                        style={{width: '100%'}}
                        onClick={() => {
                            window.open(`${operatorTicketUrl}/${selectedTicketType}/${selectedTicket?.code}?atag=${initialAtag}`, '_blank', 'noopener,noreferrer');
                            setActionsGridOpened(false);
                        }}
                    >
                        <i className="f7-icons size-18" style={{marginRight: 8}}>arrow_up_right</i>
                        View Ticket
                    </ActionsButton>
                </ActionsGroup>
            </Actions>
            <MainToolBar />
            <QRCodeModal
                ticketCode={selectedTicket?.code}
                opened={qrModalOpened}
                onClose={() => setQrModalOpened(false)}
                qrUrl={qrUrl}
            />
        </Page>
    );
};
